module.exports = __webpack_public_path__ + "static/media/Google_play_symbol.e1357a93.png";